import React , {useState} from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import UserRow from "./UserRow"; // Usa o novo UserRow.js

const UsersTable = ({ users, onDelete, onUpdateDiscount, onUpdateTags, onRenewalNotified, onUpdateUser }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeMenuId, setActiveMenu] = useState(null); 

  return (
    <Box
      sx={{
        p: isMobile ? 1 : 2,
        width: "100%",
        overflowX: "hidden",
      }}
    >
      {users.map((user, index) => (
        <UserRow
        key={`${user.id}-${user.discount_type}-${user.discount_notified}-${user.access_hold_active}-${user.access_hold_created_at || "none"}`}
        user={user}
          onDelete={onDelete}
          onUpdateDiscount={onUpdateDiscount}
          onUpdateTags={onUpdateTags} 
          activeMenuId={activeMenuId} 
          setActiveMenu={setActiveMenu}
          onRenewalNotified={onRenewalNotified}
          onUpdateUser={onUpdateUser} 
        />
      ))}
    </Box>
  );
};

export default UsersTable;
